export default __webpack_public_path__ + "static/media/miguel-lopes-21.d822ccd5.jpg";